interface SelectionState {
  text: string;
  rect: DOMRect;
}

interface Props {
  selection: SelectionState;
  onAnnotate: () => void;
  onDismiss: () => void;
}

export function SelectionToolbar({ selection, onAnnotate, onDismiss }: Props) {
  const top = selection.rect.top - 48;
  const left = Math.min(
    Math.max(selection.rect.left + selection.rect.width / 2, 80),
    window.innerWidth - 80,
  );

  return (
    <div
      className="sel-toolbar fixed z-50 flex gap-0.5 rounded-xl bg-[#1a1a1a] px-1 py-1 shadow-2xl"
      style={{ top, left, transform: 'translateX(-50%)', whiteSpace: 'nowrap', pointerEvents: 'all' }}
    >
      <button
        className="rounded-md px-2.5 py-1 text-xs text-white transition-colors hover:bg-white/15"
        onClick={onAnnotate}
      >
        ✏️ Annotate
      </button>
      <div className="my-1 w-px bg-white/20" />
      <button
        className="rounded-md px-2.5 py-1 text-xs text-white transition-colors hover:bg-white/15"
        onClick={() => { navigator.clipboard?.writeText(selection.text); onDismiss(); }}
      >
        Copy
      </button>
      <div className="my-1 w-px bg-white/20" />
      <button
        className="rounded-md px-2.5 py-1 text-xs text-white transition-colors hover:bg-white/15"
        onClick={onDismiss}
      >
        ✕
      </button>
    </div>
  );
}
